
import Vue from "vue";
import { dateToString } from "./../../../nmb/util";
import { Getter, Action } from "vuex-class";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Message } from "element-ui";
import NavBread from "../component/NavBread.vue";
import XEUtils from 'xe-utils'

@Component({
  components: {
    NavBread,
  },
})
export default class satisfaction extends Vue {
  navData: any = [
    { name: "反馈中心", to: { path: "/feedback" } },
    { name: "满意度评价" },
  ];



  $refs: {
    [key: string]: any;
    validate: HTMLFormElement;
  };

  // 表单数据
  form: any = {
    FeedbackSatisfactionGUID: "",
    FeedbackGUID: "",
    FeedbacDetailkGUID: "",
    IsSolve: "",
    IsSatisfy: "",
    Remark: "",
    CreateBy: "",
    CreateTime: "",
    ModifyBy: "",
    ModifyTime: "",
  };
  dateToString: Function = dateToString;
  @Getter feedbackSatisfactionResult: any;
  @Getter feedbackSatisfactionList: any;
  @Getter feedbackDetailV2: any;
  @Action("FeedbackSatisfaction") FeedbackSatisfaction: Function;
  @Action("getFeedbackSatisfactionList") getFeedbackSatisfactionList: Function;
  @Action getFeedbackDetailByIdV2: Function;
  user: any = {};
  view: any;
  viewEnable: boolean = false;
  btndissable: boolean = false;
  fromType: any;
  HotWord :any   = [
  {word:'反馈响应慢'},
 {word:'问题推诿'},
  {word:'沟通不畅'},
  {word:'未解决问题'},
  {word:'未采纳合理建议'},
  {word:'其他'}
];
  created() {
    this.user = JSON.parse(localStorage.logonUser);
    this.view = this.$route.query.view;
    this.fromType = this.$route.query.FromType;
    // 先查询一次，如果有数据 view 显示，如果没有数据 add显示
    this.getFeedbackSatisfactionList({
      FeedbackGUID: this.$route.query.FeedbackGUID,
      FeedbackDetailGUID:this.$route.query.FeedbackDetailGUID,
    });
  }


  @Watch("feedbackSatisfactionList.loading")
  Watchmounted() {
    if (this.feedbackSatisfactionList.loading == false && this.feedbackSatisfactionList.success==true) {
      var data = this.feedbackSatisfactionList.data;
      this.form.Remark = data.Remark;
      this.form.IsSolve = data.IsSolve ? 1 : 0;
      this.form.IsSatisfy = data.IsSatisfy ? 1 : 0;
      this.form.CreateBy = data.CreateBy;
      this.form.CreateTime = data.CreateTime;
      // 如果查询到数据 并且单的状态不是已关闭 显示view
      this.viewEnable=true;
    }
  }

  // 校验选择子系统
  validate(body: any) {

    if (body.IsSatisfy === null || body.IsSatisfy === "") {
      Message.warning("请选择是否满意！");
      return false;
    }
    if(body.IsSatisfy==0&&XEUtils.isEmpty(XEUtils.trim(body.Remark))){
      Message.warning("请填写评价意见！");
      return false;
    }
    return true;
  }

  // 提交
  onSubmit(formName: string) {
    this.form.FromType =
      this.$route.query.FromType == "" ? "List" : this.$route.query.FromType;
    this.form.FeedbackGUID = this.$route.query.FeedbackGUID;
    const body = Object.assign({}, this.form);
    if (this.validate(body)) {
      this.btndissable = true;
      this.FeedbackSatisfaction({
        FeedbackGUID: this.$route.query.FeedbackGUID,
        FeedbackDetailGUID: this.$route.query.FeedbackDetailGUID,
        FromType:
          this.$route.query.FromType == "" || this.$route.query.FromType == null
            ? "List"
            : this.$route.query.FromType,
        IsSolve: 1,
        IsSatisfy: body.IsSatisfy,
        Remark: body.Remark,
        CreateBy: this.user.UserName,
        CreateTime: new Date(),
        ModifyBy: this.user.UserName,
        ModifyTime: new Date(),
      });
      //this.Close();
    }
  }

  @Watch("feedbackSatisfactionResult.loading")
  watchfeedbackSatisfactionResult() {
    if (this.feedbackSatisfactionResult.loading == false) {
      // 邮件提交后不跳转
      setTimeout(() => {
        if (this.$route.query.FromType == "Mail") {
          this.$router.go(0);
        } else {
          this.Close();
          //this.$router.go(-1);
        }
      }, 500);
    }
  }

  // 关闭
  Close() {
    const type = this.$route.query.FromType;
    if (type == "List") {
      this.$router.push({
        path: "/feedback",
        query: { activeIndex: "2" },
      });
    } else if (type == "Detail" || type == "Mail") {
      // 点击跳转到详情
      this.$router.push({
        path: "/feedback/detail",
        query: {
          FeedbackGUID: this.$route.query.FeedbackGUID,
          TypeEnum: this.$route.query.TypeEnum,
        },
      });
    }
  }

  getText(val: string) {
    // return val ? val.replace(new RegExp('(\r\n)|(\n)', 'g'), '<br/>') : '--';
    return val ? val.replace(/\\r\\n/g, "<br/>") : "";
  }

  PutHotWord(val:string){
    var s=this.form.Remark+ '';
    if((s+val+'; ').length>500){
      Message.warning("字符超长！");
      return;
    }
    this.form.Remark  = s+val+'; ';
    this.form.Remark=this.form.Remark+''.substr(0,500);    
  }
}
